<template>
    <form name="devis_panne_mecanique_standard" @submit.prevent="onSubmit">
        <div class="row">
            <div class="col-12">
                <div class="page__head-title page__head-title--orange">
                    <div class="page__head-title__text page__head-title__text--orange">Garantie Moto</div>
                    <div class="page__head-title__notice">(* champs obligatoires)</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form_ttl">Informations sur le v&eacute;hicule &agrave; assurer :</div>
            </div>
            <!--immatriculation-->
            <div class="col-12">
                <div class="form__item relative">
                    <div class="form__item__label form__item__label--required">Immatriculation</div>
                    <div class="form__item__input-wrapper" :class="{ 'input-addon':existingVehicleFound || isVehicleSearching }">
                        <input
                                v-model="garantieMoto.immatriculation"
                                class="input_n"
                                @input="searchByRegNumber"
                                :class="{input_red_shadow: hasError('immatriculation')}"
                        />

                        <div class="form__item__input-wrapper--loader" v-if="isVehicleSearching">
                            <Preloader :wrapper-height="'20px'" :size="'20px'" />
                        </div>
                        <!-- <button type="button" @click="fillTheFieldsByImmatriculation" class="form_bt form_confirm_button form__item__submit__button--small-helper" v-if="existingVehicleFound && !isVehicleSearching">
                            Compléter
                        </button> -->
                    </div>
                    <div class="tooltip__wrap">
                        <div class="tooltip__wrap--icon"></div>

                        <div class="tooltip__wrap--text">
                            <div class="tooltip__wrap--text--notice">Veuillez saisir l'immatriculation du véhicule en lettres majuscules et séparés par un trait d'union. Exemple: AF-785-HT</div>

                        </div>
                    </div>
                </div>
            </div>
            <!--marque-->
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Marque</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="garantieMoto.marque_auto" name="marque_auto"
                               id="marque_auto"
                               class="input_n"
                               :disabled="searchVehicleFilled"
                               :class="{input_red_shadow: hasError('marque_auto')}"/>
                    </div>
                </div>
            </div>
            <!--modele-->
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Modèle</div>
                    <div class="form__item__input-wrapper">
                        <input v-model="garantieMoto.modele_porteur" class="input_n"
                               :disabled="searchVehicleFilled"
                               :class="{input_red_shadow: hasError('modele_porteur')}"/>
                    </div>
                </div>
            </div>
            <!--cylindre-->
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Cylindr&eacute;e</div>
                    <div class="form__item__input-wrapper">
                        <select v-model="garantieMoto.cylindree" class="select_n" :disabled="searchVehicleFilled" :class="{input_red_shadow: hasError('cylindree')}">
                            <option v-for="(cylinder, key) in list_cylinders_moto" :value="key">{{ cylinder }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <!--serial number-->
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Num&eacute;ro de s&eacute;rie</div>
                    <div class="form__item__input-wrapper">
                        <input v-model="garantieMoto.num_serie" class="input_n"
                               :disabled="searchVehicleFilled"
                               :class="{input_red_shadow: hasError('num_serie')}"/>
                    </div>
                </div>
            </div>
            <!--km jour vente-->
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Kilométrage</div>
                    <div class="form__item__input-wrapper">
                        <input v-model="garantieMoto.km_jour_vente" class="input_n" :class="{input_red_shadow: hasError('km_jour_vente')}"/>
                    </div>
                </div>
            </div>
            <!--date 1st circulation-->
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Date de 1&egrave;re mise en circulation</div>
                    <div class="form__item__input-wrapper form__item__input-wrapper--date currency-datepicker">
                        <CustomDatepicker :date.sync="circulationDateInput" :disabled="searchVehicleFilled" :has-error="hasError('sale_date')"></CustomDatepicker>
                    </div>
                </div>
            </div>
            <!--effective date-->
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Date d'effet</div>
                    <div class="form__item__input-wrapper form__item__input-wrapper--date currency-datepicker">
                        <CustomDatepicker :date.sync="effectiveDateInput" :has-error="hasError('effective_date')"></CustomDatepicker>
                    </div>
                </div>
            </div>
            <!--app commerciale-->
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label">Appellation commerciale</div>
                    <div class="form__item__input-wrapper">
                        <input v-model="garantieMoto.app_commerciale" class="input_n" :class="{input_red_shadow: hasError('app_commerciale')}" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form_ttl">Information sur la garantie :</div>
            </div>
            <!--garantie-->
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Garantie</div>
                    <div class="form__item__input-wrapper">
                        <select v-model="garantieMoto.garantie" class="select_n" :class="{input_red_shadow: hasError('garantie')}" >
                            <option value="0" selected="selected">Choisissez une garantie</option>
                            <option value="1">Standard</option>
                            <option value="2">Complète</option>
                        </select>
                    </div>
                </div>
            </div>
            <!--duration-->
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Dur&eacute;e</div>
                    <div class="form__item__input-wrapper">
                        <select v-model="garantieMoto.duree" class="select_n" :class="{input_red_shadow: hasError('duree')}" >
                            <option value="0">Choisir une dur&eacute;e...</option>
                            <option value="1">3 Mois</option>
                            <option value="2">6 Mois</option>
                            <option value="3">12 Mois</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form_ttl_first">Informations sur le propri&eacute;taire du v&eacute;hicule :</div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label">Civilit&eacute;</div>
                    <div class="form__item__input-wrapper">
                        <select v-model="garantieMoto.civilite">
                            <option value="0">M</option>
                            <option value="1">Mlle</option>
                            <option value="2">Mme</option>
                            <option value="3">Société</option>
                            <option value="4">Mr et Mme</option>
                        </select>
                    </div>
                </div>
            </div>

            <template v-if="garantieMoto.civilite == 3">
                <div class="col-12">
                    <div class="form__item">
                        <div class="form__item__label form__item__label--required">Société</div>
                        <div class="form__item__input-wrapper">
                            <input type="text" v-model="garantieMoto.name_of_signatory" name="name_of_signatory"
                                   id="name_of_signatory" class="input_n" :class="{input_red_shadow: hasError('name_of_signatory')}" />
                        </div>
                    </div>
                </div>
                <div class="col-12">
                  <div class="form__item">
                    <div class="form__item__label form__item__label--required">Nom du signataire</div>
                    <div class="form__item__input-wrapper">
                      <input type="text" v-model="garantieMoto.nom" name="nom" id="nom" class="input_n" :class="{input_red_shadow: hasError('nom')}" />
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form__item">
                    <div class="form__item__label form__item__label--required">Pr&eacute;nom du signataire</div>
                    <div class="form__item__input-wrapper">
                      <input type="text" v-model="garantieMoto.prenom" name="prenom" id="prenom"
                             class="input_n" :class="{input_red_shadow: hasError('prenom')}" />
                    </div>
                  </div>
                </div>
            </template>

            <template v-else>
                <div class="col-12">
                  <div class="form__item">
                    <div class="form__item__label form__item__label--required">Nom</div>
                    <div class="form__item__input-wrapper">
                      <input type="text" v-model="garantieMoto.nom" name="nom" id="nom" class="input_n" :class="{input_red_shadow: hasError('nom')}" />
                    </div>
                  </div>
                </div>
                <div class="col-12">
                    <div class="form__item">
                        <div class="form__item__label form__item__label--required">Pr&eacute;nom</div>
                        <div class="form__item__input-wrapper">
                            <input type="text" v-model="garantieMoto.prenom" name="prenom" id="prenom"
                                   class="input_n" :class="{input_red_shadow: hasError('prenom')}" />
                        </div>
                    </div>
                </div>
            </template>

            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Adresse</div>
                    <div class="form__item__input-wrapper">
                        <input v-model="garantieMoto.adresse" class="input_n" :class="{input_red_shadow: hasError('adresse')}" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Code postal</div>
                    <div class="form__item__input-wrapper">
                        <input v-model="garantieMoto.cp" maxlength="5" class="input_n" :class="{input_red_shadow: hasError('cp')}" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Ville</div>
                    <div class="form__item__input-wrapper">
                        <input v-model="garantieMoto.ville" class="input_n" :class="{input_red_shadow: hasError('ville')}" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">T&eacute;l&eacute;phone</div>
                    <div class="form__item__input-wrapper" :class="{ 'input-addon': existingCustomerFound || isClientSearching }">
<!--                        <input v-model="garantieMoto.tel" @input="searchClient" maxlength="10" class="input_n" :class="{input_red_shadow: hasError('tel')}" />-->
                      <input v-model="garantieMoto.tel" maxlength="10" class="input_n" :class="{input_red_shadow: hasError('tel')}" />

                        <div class="form__item__input-wrapper--loader" v-if="isClientSearching">
                          <Preloader :wrapper-height="'20px'" :size="'20px'" />
                        </div>
                        <!-- <button type="button" @click="fillTheFields" class="form_bt form_confirm_button form__item__submit__button--small-helper" v-if="existingCustomerFound && !isClientSearching">
                          Compléter
                        </button> -->
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label">Fax</div>
                    <div class="form__item__input-wrapper">
                        <input v-model="garantieMoto.fax" maxlength="10" class="input_n" :class="{input_red_shadow: hasError('fax')}" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label">Email</div>
                    <div class="form__item__input-wrapper">
                        <input v-model="garantieMoto.email" class="input_n"
                               :class="{input_red_shadow: hasError('email')}"
                        />
                    </div>
                </div>
            </div>

            <!--submit-->
            <div class="col-12">
                <div class="form__item justify-content-center mt-3 mb-3">
                    <div class="form__item__submit">
                        <Preloader v-if="isSending"  />
                        <input v-else type='submit' name="Submit" value="VOIR LE DEVIS" class="form_bt form_confirm_button form__item__submit__button btn btn-block"/>
                    </div>
                </div>
            </div>
        </div>
        <ValidationErrors :errorsList="errors"/>
    </form>
</template>

<script>
    import ValidationErrors from '@/components/Garantie/ValidationErrors';
    import garantieFieldsLists from '../../mixins/garantieFieldsLists';
    import Preloader from '@/components/Preloader'
    import {DEBOUNCE} from "@/mixins/helper";
    import {TheMask} from 'vue-the-mask'
    import CustomDatepicker from '@/components/CustomInputs/CustomDatepicker';

    const INITIAL_FIELDS_VALUES = Object.freeze({
        civilite: 0,
        nom: '',
        prenom: '',
        name_of_signatory: '',
        adresse: '',
        cp: '',
        ville: '',
        tel: '',
        fax: '',
        email: '',
        garantie: 0,
        immatriculation: '',
        num_serie: '',
        marque_auto: '',
        modele_porteur: '',
        app_commerciale: '',
        jour_mise_en_circulation: 1,
        mois_mise_en_circulation: 1,
        annee_mise_en_circulation: new Date().getFullYear(),
        km_jour_vente: '',
        cylindree: 0,
        jour_prise_effet: '',
        mois_prise_effet: '',
        annee_prise_effet: '',
        duree: 0,
    });

    const CAR_TYPE_VP = 1;
    const CAR_TYPE_VU = 2;
    const CAR_TYPE_4X4 = 3;

    const CIVILITY_M = 0;
    const CIVILITY_MLLE = 1;
    const CIVILITY_MME = 2;
    const CIVILITY_SOCIETY = 3;

    export default {
        name: "GarantieMotos",
        components: {ValidationErrors, Preloader, TheMask, CustomDatepicker},
        mixins: [garantieFieldsLists],
        data() {
            return {
                isSending: false,
                garantieMoto: {...INITIAL_FIELDS_VALUES},
                errors: {},
                searchResult: null,
                isClientSearching: false,
                searchVehicleResult: null,
                isVehicleSearching: false,
                effectiveDateInput: '',
                circulationDateInput: '',
                searchVehicleFilled: false
            }
        },
        computed: {
            isNewInsurance() {
                return !this.$route.params.id;
            },
            existingCustomerFound() {
                return !!this.searchResult;
            },
            existingVehicleFound() {
                return !!this.searchVehicleResult;
            },
        },
        methods: {
            searchByRegNumber: DEBOUNCE(function(val) {
                this.garantieMoto.immatriculation = this.garantieMoto.immatriculation.toUpperCase();

                let matched = this.garantieMoto.immatriculation.match(/(^([A-Z]{2}-[0-9]{3}-[A-Z]{2})+$)|(^([0-9]{3}-[A-Z]{3}-[0-9]{2})+$)/g);

                if (matched) {
                    let url = 'client/registration',
                        data = {
                            regNumber: this.garantieMoto.immatriculation
                        };
                    this.isVehicleSearching = true;
                    this.apiPost(url, data, false)
                        .then(response => {
                            if (response.data.info) {
                                this.searchVehicleResult = response.data.info;
                                this.parseVehicleInfo(this.searchVehicleResult);
                                this.searchVehicleFilled = true;
                            }

                            this.isVehicleSearching = false;
                        })
                        .catch(error => {
                            this.showErrorNotification(error);
                            this.isVehicleSearching = false;
                        })
                }
            }, 1000),
            searchClient: DEBOUNCE(function(val) {

                if (this.garantieMoto.tel.length > 2) {
                    let url = 'client/searchOne',
                        data = {
                            tel: this.garantieMoto.tel
                        };
                    this.isClientSearching = true;
                    this.apiGet(url, data, false)
                        .then(response => {
                            if (response.data.client) {
                                this.searchResult = response.data.client;
                                this.parseClientInfo(this.searchResult);
                                this.searchResult = null;
                            }

                            this.isClientSearching = false;
                        })
                        .catch(error => {
                            this.showErrorNotification(error);
                            this.isClientSearching = false;
                        })
                }
            }, 1000),
            fillTheFieldsByImmatriculation() {
                if (this.searchVehicleResult) {
                    this.parseVehicleInfo(this.searchVehicleResult);
                    this.searchVehicleFilled = true;
                    // this.searchVehicleResult = null;
                }
            },
            parseVehicleInfo(info) {
                // /* Car brand */
                if (info.Marque) {
                    this.garantieMoto.marque_auto = info.Marque.split('.').join('');
                }
                //
                // /* Modele */
                this.garantieMoto.modele_porteur = info.Modele ? info.Modele.toLocaleString() : null;
                /* Num serie */
                this.garantieMoto.num_serie = info.VIN ? info.VIN : null;

                // /* Cylindree */
                if (info.Cylindree) {
                    let cylindree = +info.Cylindree;

                    if (cylindree > 650) {
                        this.garantieMoto.cylindree = 3;
                    } else if (cylindree >= 125 && cylindree <= 650) {
                        this.garantieMoto.cylindree = 2;
                    } else if (cylindree < 125) {
                        this.garantieMoto.cylindree = 1;
                    }
                }

                if (info.DateMec) {
                    this.circulationDateInput = new Date(info.DateMec);
                }
            },
            fillTheFields() {
                if (this.searchResult) {
                    this.parseClientInfo(this.searchResult);
                    this.searchResult = null;
                }
            },
            serializeData() {
                return this.garantieMoto;
            },
            onSubmit(event) {
                this.garantieMoto.immatriculation = this.garantieMoto.immatriculation.toUpperCase();
                this.validateEffectiveDate();
                this.validateCirculationDate();
                this.isSending = true;
                let url = 'garantie/motos',
                    data = this.serializeData();

                if (!this.isNewInsurance ) {
                    url = 'garantie/motos/' + this.$route.params.id + '/edit';
                }

                this.apiPost(url, data)
                    .then((response) => {
                        this.isSending = false;
                        this.errors = {};
                        let id = response.data.quote.id;
                        if (response.data.calcQuotes)
                            this.$store.dispatch('updateCalcGaranties', response.data.calcQuotes);
                        this.showSuccessNotification(response.data.message, '');
                        this.$router.push('/garantie-motos-view/' + id);
                    })
                    .catch(error => {
                        this.isSending = false;
                        this.errors = error.response.data;

                        if(error.response.data.exception === 'App\\Exceptions\\PriceErrorException') {
                            this.errors.errors = {};
                            this.errors.errors.error = [error.response.data.message];
                        }
                    })
            },
            loadQuoteInfo() {
                if (!this.isNewInsurance) {
                    let url = 'garantie/' + this.$route.params.id;
                    this.apiGet(url)
                        .then(response => {
                            this.garantieMoto = this.parseQuoteInfo(response.data.quote);
                        })
                        .catch(error => {
                            this.showErrorNotification(error);
                        })
                }
            },
            parseClientInfo(client) {
                this.garantieMoto.civilite = client.civility;
                this.garantieMoto.nom = client.last_name;
                this.garantieMoto.prenom = client.first_name;
                this.garantieMoto.adresse = client.address;
                this.garantieMoto.cp = client.zip;
                this.garantieMoto.ville = client.city;
                this.garantieMoto.tel = client.tel;
                this.garantieMoto.email = client.email;
                this.garantieMoto.fax = client.fax;
                this.garantieMoto.id_client = client.id;
            },
            parseQuoteInfo(quote) {
                let parsedQuote = {};

                if (quote.client && quote.client.id) {
                    parsedQuote.civilite = quote.client.civility;
                    parsedQuote.nom = quote.client.last_name;
                    parsedQuote.prenom = quote.client.first_name;
                    parsedQuote.name_of_signatory = quote.client.name_of_signatory;
                    parsedQuote.adresse = quote.client.address;
                    parsedQuote.cp = quote.client.zip;
                    parsedQuote.ville = quote.client.city;
                    parsedQuote.tel = quote.client.tel;
                    parsedQuote.email = quote.client.email;
                    parsedQuote.id_client = quote.client.id;
                    parsedQuote.fax = quote.client.fax;
                }

                if (quote.details) {
                    parsedQuote.garantie = quote.details.garantie;
                    parsedQuote.immatriculation = quote.details.registration;
                    parsedQuote.num_serie = quote.details.serial_number;
                    parsedQuote.marque_auto = quote.details.car_brand;
                    parsedQuote.modele_porteur = quote.details.modele_porteur;
                    parsedQuote.app_commerciale = quote.details.app_commercial;
                    parsedQuote.jour_mise_en_circulation = quote.details.day_circulation;
                    parsedQuote.mois_mise_en_circulation = quote.details.month_circulation;
                    parsedQuote.annee_mise_en_circulation = quote.details.year_circulation;
                    parsedQuote.km_jour_vente = quote.details.km_sale_day;
                    parsedQuote.cylindree = quote.details.cylinder;

                    let effective_day = quote.details.datesParse.day_effective,
                        effective_month = quote.details.datesParse.month_effective - 1,
                        effective_year = quote.details.datesParse.year_effective;


                    this.effectiveDateInput = new Date(effective_year, effective_month , effective_day);

                    this.circulationDateInput = new Date(
                        quote.details.year_circulation,
                        quote.details.month_circulation - 1,
                        quote.details.day_circulation,
                    );

                    parsedQuote.duree = quote.details.duration;
                }

                return parsedQuote;
            },
            validateEffectiveDate() {
                if(!this.effectiveDateInput) return false;
                let date = this.moment(this.effectiveDateInput);

                this.garantieMoto.jour_prise_effet = date.format('D');
                this.garantieMoto.mois_prise_effet = date.format('M');
                this.garantieMoto.annee_prise_effet = date.format('YYYY');

                return true;
            },
            resetEffectiveDate() {
                this.garantieMoto.jour_prise_effet = 1;
                this.garantieMoto.mois_prise_effet = 1;
                this.garantieMoto.annee_prise_effet = 1970;
            },
            cleanEffectiveDate() {
                this.garantieMoto.jour_prise_effet = '';
                this.garantieMoto.mois_prise_effet = '';
                this.garantieMoto.annee_prise_effet = '';
            },
            validateCirculationDate() {
                if(!this.circulationDateInput) return false;
                let date = this.moment(this.circulationDateInput);

                this.garantieMoto.jour_mise_en_circulation = date.format('D');
                this.garantieMoto.mois_mise_en_circulation = date.format('M');
                this.garantieMoto.annee_mise_en_circulation = date.format('YYYY');

                return true;
            },
            resetCirculationDate() {
                this.garantieMoto.jour_mise_en_circulation = 1;
                this.garantieMoto.mois_mise_en_circulation = 1;
                this.garantieMoto.annee_mise_en_circulation = 2100;
            },
            hasError(field) {
                return !!(this.errors.errors && this.errors.errors[field]);
            },
        },
        beforeRouteLeave(to, from, next) {
            this.garantieMoto = INITIAL_FIELDS_VALUES;
            next();
        },
        mounted() {
            this.loadQuoteInfo();
            this.searchVehicleFilled = true;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Garantie/GarantieMotos.vue